import { Button } from '@cian/ui-kit';

import * as React from 'react';

export interface ICancelButton {
  isMobile?: boolean;
  onClick(event: React.SyntheticEvent<HTMLButtonElement>): void;
}

export const CancelButton: React.FC<ICancelButton> = ({ isMobile, onClick }) => {
  const buttonSize = isMobile ? 'M' : 'XS';
  const buttonTheme = isMobile ? 'fill_secondary' : 'stroke_secondary';

  return (
    <Button size={buttonSize} theme={buttonTheme} type="button" onClick={onClick} fullWidth={isMobile}>
      Отменить
    </Button>
  );
};

CancelButton.displayName = 'CancelButton';
